type FetchErrorLike = {
  message?: string
  request?: string
  status?: number
  statusCode?: number
  statusMessage?: string
  response?: {
    status?: number
    statusText?: string
    url?: string
  }
}

export const getFetchErrorSummary = (error: unknown) => {
  const fetchError = error as FetchErrorLike

  return {
    statusCode: fetchError?.statusCode ?? fetchError?.status ?? fetchError?.response?.status,
    statusMessage: fetchError?.statusMessage ?? fetchError?.response?.statusText,
    request: fetchError?.request ?? fetchError?.response?.url,
    message: fetchError?.message,
  }
}

export const logFetchWarning = (message: string, error: unknown) => {
  console.warn(message, getFetchErrorSummary(error))
}
